import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { http } from "../../components/helper";

export const placeOrder = createAsyncThunk(
  "order/placeOrder",
  async (payload) => {
    const response = await http.post("order", payload);
    return response.data;
  }
);
export const placeKitchenOrder = createAsyncThunk(
  "order/placeKitchenOrder",
  async (payload) => {
    const response = await http.post("kitchenorder", payload);
    return response.data;
  }
);
export const fetchOrders = createAsyncThunk(
  "order/fetchOrders",
  async (payload) => {
    const response = await http.post("orders", payload);
    return response.data;
  }
);
export const fetchKitchenOrders = createAsyncThunk(
  "order/fetchKitchenOrders",
  async (payload) => {
    const response = await http.post("kitchen-orders", payload);
    return response.data;
  }
);
export const searchOrders = createAsyncThunk(
  "order/searchOrders",
  async ({ accountCode, searchField, searchText }) => {
    const response = await http.get(`searchorders/${accountCode}/${searchField}/${encodeURIComponent(searchText)}`);
    return response.data;
  }
);

export const updateOrders = createAsyncThunk(
  "order/updateOrders",
  async ({ accountCode, orderNumber }) => {
    const response = await http.get(`updateorderitems/${accountCode}/${orderNumber}`);
    return response.data;
  }
);

export const getOrders = createAsyncThunk(
  "order/getOrders",
  async ({ orderNumber }) => {
    const response = await http.get(`order/${orderNumber}`);
    return response.data;
  }
);

export const getKitchenOrders = createAsyncThunk(
  "order/getKitchenOrders",
  async ({ orderNumber }) => {
    const response = await http.get(
      `admin/getkitchenorderdetails/${orderNumber}`
    );
    return response.data;
  }
);

export const getUnPaidOrders = createAsyncThunk(
  'order/getUnPaidOrders',
  async (payload) => {
    const response = await http.post('unpaidorders', payload);
    return response.data.data;
  }
);


const initialState = {
  orderInfo: [],
  kitchenOrderInfo: [], 
  orderList: [],
  searchOrderList: [],
  viewOrder: [],
  getOrderInfo: [],
  placeOrderStatus: "idle",
  fetchOrderStatus: "idle",
  getOrderStatus: "idle",
  searchOrderStatus: "idle",
  updateOrderStatus: "idle",
  error: null,
  unPaidOrders: [],
  unPaidOrderStatus: 'idle',
  unPaidError: null,
  placeKitchenOrderStatus: "idle",
  kitchenOrderList: [],
  fetchKitchenOrderStatus: "idle",
};

const orderSlice = createSlice({
  name: "Orders",
  initialState,
  reducers: {
    resetOrderInfo(state) {
      state.orderInfo = [];
      state.placeOrderStatus = "idle";
    },
    resetKitchenOrderInfo(state) {
      state.kitchenOrderInfo = [];
      state.placeKitchenOrderStatus = "idle";
    },
    resetGetOrderInfo(state) {
      state.getOrderInfo = [];
      state.getOrderStatus = "idle";
    },
    resetOrderList(state) {
      state.fetchOrderStatus = "idle";
      state.orderList = [];
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(placeOrder.pending, (state) => {
        state.placeOrderStatus = "loading";
      })
      .addCase(placeOrder.fulfilled, (state, action) => {
        state.placeOrderStatus = "succeeded";
        state.orderInfo = action.payload;
      })
      .addCase(placeOrder.rejected, (state, action) => {
        state.placeOrderStatus = "failed";
        state.error = action.error.message;
      })
      .addCase(placeKitchenOrder.pending, (state) => {
        state.placeKitchenOrderStatus = "loading";
      })
      .addCase(placeKitchenOrder.fulfilled, (state, action) => {
        state.placeKitchenOrderStatus = "succeeded";
        state.kitchenOrderInfo = action.payload;
      })
      .addCase(placeKitchenOrder.rejected, (state, action) => {
        state.placeKitchenOrderStatus = "failed";
        state.error = action.error.message;
      })
      .addCase(fetchOrders.pending, (state) => {
        state.fetchOrderStatus = "loading";
      })
      .addCase(fetchOrders.fulfilled, (state, action) => {
        state.fetchOrderStatus = "succeeded";
        state.orderList = action.payload;
      })
      .addCase(fetchOrders.rejected, (state, action) => {
        state.fetchOrderStatus = "failed";
        state.error = action.error.message;
      })
      .addCase(fetchKitchenOrders.pending, (state) => {
        state.fetchKitchenOrderStatus = "loading";
      })
      .addCase(fetchKitchenOrders.fulfilled, (state, action) => {
        state.fetchKitchenOrderStatus = "succeeded";
        state.kitchenOrderList = action.payload;
      })
      .addCase(fetchKitchenOrders.rejected, (state, action) => {
        state.fetchKitchenOrderStatus = "failed";
        state.error = action.error.message;
      })
      .addCase(searchOrders.pending, (state) => {
        state.searchOrderStatus = "loading";
      })
      .addCase(searchOrders.fulfilled, (state, action) => {
        state.searchOrderStatus = "succeeded";
        state.searchOrderList = action.payload;
      })
      .addCase(searchOrders.rejected, (state, action) => {
        state.searchOrderStatus = "failed";
        state.error = action.error.message;
      })
      .addCase(updateOrders.pending, (state) => {
        state.updateOrderStatus = "loading";
      })
      .addCase(updateOrders.fulfilled, (state, action) => {
        state.updateOrderStatus = "succeeded";
        state.viewOrder = action.payload;
      })
      .addCase(updateOrders.rejected, (state, action) => {
        state.updateOrderStatus = "failed";
        state.error = action.error.message;
      })
      .addCase(getOrders.pending, (state) => {
        state.getOrderStatus = "loading";
      })
      .addCase(getOrders.fulfilled, (state, action) => {
        state.getOrderStatus = "succeeded";
        state.getOrderInfo = action.payload;
      })
      .addCase(getOrders.rejected, (state, action) => {
        state.getOrderStatus = "failed";
        state.error = action.error.message;
      })
      .addCase(getKitchenOrders.pending, (state) => {
        state.getOrderStatus = "loading";
      })
      .addCase(getKitchenOrders.fulfilled, (state, action) => {
        state.getOrderStatus = "succeeded";
        state.getOrderInfo = action.payload;
      })
      .addCase(getKitchenOrders.rejected, (state, action) => {
        state.getOrderStatus = "failed";
        state.error = action.error.message;
      })
      .addCase(getUnPaidOrders.pending, (state) => {
        state.unPaidOrderStatus = 'loading';
      })
      .addCase(getUnPaidOrders.fulfilled, (state, action) => {
        state.unPaidOrderStatus = 'succeeded';
        state.unPaidOrders = action.payload;
      })
      .addCase(getUnPaidOrders.rejected, (state, action) => {
        state.unPaidOrderStatus = 'failed';
        state.unPaidError = action.error.message;
      });
  },
});

export const { resetOrderInfo, resetKitchenOrderInfo, resetOrderList, resetGetOrderInfo } =
  orderSlice.actions;
export default orderSlice.reducer;
